import { httpClient } from "./httpClient";

const base = "/api/puestos";

export const listarPuestos  = ()           => httpClient.get(base);
export const crearPuesto    = (datos)      => httpClient.post(base, datos);
export const actualizarPuesto = (id, datos) => httpClient.put(`${base}/${id}`, datos);
export const eliminarPuesto = (id)         => httpClient.del(`${base}/${id}`);

const puestosService = { listar: listarPuestos, crear: crearPuesto, actualizar: actualizarPuesto, eliminar: eliminarPuesto };
export default puestosService;
